import React from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import { Dialog, LoadMore } from 'react-weui'
import { isLZWKAPP, removeAds } from '../utils'
import { Page, InfiniteScroll, WKVisible } from '../components'
import banner from '../images/lecture/share-banner-new.png'
import '../css/page/LectureShareRankPage.css'


class LectureShareRankPage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            isShowDialog: false,
            ranks: null,
            myRank: null,
            account: {},
            selectedUid: '',
            detailList: null,
            detailOffset: 0,
            isDetailListAsking: false,
            detailListHasMore: true,
        }
    }
    componentDidMount () {
        document.title = '人气榜'
        this.fetchRankList()
    }
    fetchRankList () {
        axios.get(`/api/lecture/${this.props.params.lecture_id}/sharerank/list`)
            .then(res => {
                this.setState({ ranks: res.data.data.ranks, myRank: res.data.data.my_rank, account: res.data.data.account })
            })
    }
    fetchRankDetail (id) {
        this.setState({ isDetailListAsking: true })
        axios.get(`/api/lecture/${this.props.params.lecture_id}/sharerank/${id}/detail?offset=${this.state.detailOffset}`)
            .then(res => {
                this.setState({
                    detailList: (this.state.detailList || []).concat(res.data.data.accounts), 
                    detailOffset: res.data.data.next_offset, 
                    isDetailListAsking: false,
                    detailListHasMore: res.data.data.has_more,
                })
            })
    }
    onClickRank (id) {
        this.setState({ isShowDialog: true, selectedUid: id })
        this.fetchRankDetail(id)
    }
    renderRank (item, index) {
        return (
            <div key={index} className="weui-flex item-padding rank-item" onClick={() => this.onClickRank(item.account.id)}>
                <div className="weui-flex__item flex_2">
                    <div className="portrait">
                        <img src={item.account.avatar_url} />
                    </div>
                </div>
                <div className="weui-flex__item flex_10">
                    <p className='big-font'>{index + 1}. {removeAds(item.account.nickname)}</p>
                    <p className="text-minor">近半年带了<span className="key-num">{item.count}</span>个朋友来听课</p>
                </div>
            </div>
        )
    }
    handleClickDialogClose () {
        this.setState({ isShowDialog: false, detailList: null, detailOffset: 0 })
    }
    renderRanks (ranks) {
        if (!ranks) return <LoadMore loading></LoadMore>
        return ranks.map((item, index) => this.renderRank(item, index))
    }
    handleTouchBottom () {
        this.fetchRankDetail(this.state.selectedUid)
    }
    toShareCardPage () {
        const lectureId = +this.props.params.lecture_id
        if (!isLZWKAPP()) return window.location = `/lecture/${lectureId}/sharecard`
        switch (window.systemType) {
            case 'android':
                WKApp.toShareCardPage("lecture", lectureId)
                break
            case 'ios':
                window.webkit.messageHandlers.WKApp.postMessage({
                    function: "toShareCardPage",
                    type: "lecture",
                    id: lectureId,
                })
                break
            default:
                window.location = `/lecture/${lectureId}/sharecard`
        }
    }
    render() {
        return (
            <Page>
                <div className="wk-inner-page lecture-share-rank-page">
                    <a className="header" onClick={() => this.toShareCardPage()}>
                        <img src="https://static-cos.lycheer.net/xupload/20220402_9u00877.png" alt=""/>
                    </a>
                    <Me account={this.state.account} myRank={this.state.myRank} lectureId={this.props.params.lecture_id} 
                        toShareCardPage={() => this.toShareCardPage()}
                    />
                    <div className="rank-list">
                        { this.renderRanks(this.state.ranks) }
                    </div>
                    <div className="detail-list">
                        <Dialog type="ios" title='邀请成员列表' show={this.state.isShowDialog} buttons={[{
                            label: '关闭',
                            onClick: () => this.handleClickDialogClose()
                        }]}>
                            <DetailList 
                                list={this.state.detailList} 
                                handleTouchBottom={() => this.handleTouchBottom()} 
                                isDetailListAsking={this.state.isDetailListAsking}
                                detailListHasMore={this.state.detailListHasMore}
                            />
                        </Dialog>
                    </div>
                </div>
            </Page>
        )
    }
}


function Me (props) {
    const myRank = props.myRank
    return (
        <div className="me-box">
            <div className="weui-flex item-padding">
                <div className="weui-flex__item flex_2">
                    <div className="portrait">
                        <img src={props.account.small_avatar_url} alt="" />
                    </div>
                </div>
                <div className="weui-flex__item flex_6 padding-line">
                    <p className='big-font'>我</p>
                    <WKVisible create={!myRank}>
                        <p className="text-minor">还没带朋友来一起听课哦</p>
                    </WKVisible>
                    <WKVisible create={myRank}>
                        <p className="text-minor">近半年带了<span>{myRank && myRank.count}</span>个朋友，排名第{myRank && myRank.rank}</p>
                    </WKVisible>
                </div>
                <div className="weui-flex__item flex_4 text-right padding-right btn-wrap">
                    <a onClick={props.toShareCardPage} className="weui-btn weui-btn_mini weui-btn_primary" id="share_card">邀请卡</a>
                </div>
            </div>
        </div>
    )
}


class DetailList extends React.Component {
    render () {
        const $bd = document.querySelector('.detail-list .weui-dialog__bd')
        if (this.props.list && this.props.list.length === 0) return <span className="text-minor">暂时没有成员</span>
        return (
            <div className='content clearfix' ref={r => this.$detailList = r} >
                {
                    this.props.list && this.props.list.map(item => {
                        return (
                            <li className="fl item-padding" style={{width: "25%"}} key={item.id}>
                                <div className="portrait">
                                    <img src={item.small_avatar_url} alt="" />
                                </div>
                                <p className="text-center text-ellipsis text-minor">{item.nickname}</p>
                            </li>
                        )
                    })
                }
                {this.props.isDetailListAsking && <LoadMore loading></LoadMore>}
                {
                    $bd && <InfiniteScroll 
                        el={$bd} 
                        onTouchBottom={() => this.props.handleTouchBottom()}
                        distance={100}
                        isStop={this.props.isDetailListAsking}
                        isKill={!this.props.detailListHasMore}
                    />
                }
            </div>
        )
    }
}

export default connect(state => ({
}))(LectureShareRankPage)


// WEBPACK FOOTER //
// ./src/pages/LectureShareRankPage.js